<template>
  <div class="switch-status" :class="boldClass">
    <span> {{ title }} </span>
  </div>
</template>
  <script>
/* eslint-disable */
export default {
  name: "switch-status",
  props: {
    title: {
      type: String,
      required: true,
    },
    bold: {
      type: Boolean,
    },
  },
  computed: {
    seriesList() {
      if (this.series instanceof Array) {
        return this.series;
      } else {
        return [this.series];
      }
    },
    seriesIndexList() {
      let result = [];
      if (!this.seriesList) {
        return result;
      }

      for (let i = 0; i < this.seriesList.length; i++) {
        result.push(i);
      }
      return result;
    },
    boldClass(){
      if(this.bold === true){
        return "bold"
      }
    },
  },
  methods: {
    sta(seriesItem) {
      return !seriesItem || seriesItem.data === undefined || seriesItem.data === null;
    },
    switchText(seriesItem) {
      if (!seriesItem) {
        return "";
      }

      let result = "";
      if (seriesItem.name) {
        result = seriesItem.name + " ";
      }
      if (seriesItem.data || seriesItem.data === 0) {
        result = result + seriesItem.data;
      } else {
        result = result + "--";
      }
      if (seriesItem.unit) {
        result = result + " " + seriesItem.unit;
      }

      return result;
    },
  },
};
</script>
  <style lang="scss" scoped>
@keyframes breathee-warning {
  0% {
    background-color: rgba(255, 255, 0, 0.3);
  }
  100% {
    background-color: #ffff00;
    // background: rgba(255, 255, 255, 0.7);
  }
}
.switch-status {
  height: 42px;
  display: flex;
  justify-content: space-evenly;
  background-color: rgba(255, 255, 255, 0.6);
  padding: 0 10px !important;
  box-sizing: border-box;
  width: 100%;
  align-items: center;
}
.warning-flag {
  background-color: #f7f910;
  animation: breathee-warning 1500ms infinite alternate ease-in-out;
}

.value-span {
  margin-left: 5px;
}

.bold {
  font-weight: bold;
}
</style>
  